import { render } from "./WidgetModal.vue?vue&type=template&id=04dec9bd"
import script from "./WidgetModal.vue?vue&type=script&lang=js"
export * from "./WidgetModal.vue?vue&type=script&lang=js"

import "./WidgetModal.vue?vue&type=style&index=0&id=04dec9bd&lang=scss"
script.render = render

export default script